import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';

import { AbilityService } from '../services/ability/ability.service';

const SSO_ALLOWED_URL = /^\/(working-area|reports)(\/|\?|#|$)/;

@Injectable({ providedIn: 'root' })
export class SsoScopeGuard implements CanActivate, CanActivateChild {
  constructor(private ability: AbilityService) {}

  canActivate(_: unknown, state: RouterStateSnapshot): boolean {
    if (!this.ability.isSSO) return true;

    if (!this.ability.mainLabUrl) return true;
    if (SSO_ALLOWED_URL.test(state.url)) return true;
    console.warn('[SsoScopeGuard] blocked', state.url);
    return false;
  }

  canActivateChild(child: unknown, state: RouterStateSnapshot): boolean {
    return this.canActivate(child, state);
  }
}
